export default "<p>\r\n  content-viewer works!\r\n</p>\r\n"